<template>
  <div id="powers-view" class="powers-page">
    <AppHeader>Super Powers</AppHeader>

    <main>
      <v-container>
        <section class="powers-intro" aria-labelledby="powers-title">
          <p class="powers-kicker">Reckon Crew Files</p>
          <h1 id="powers-title">Every Hero Has a Power Set</h1>
          <p>
            Each Reckon Crew member has a super powers profile ready for origin stories,
            abilities, and the copy you want to add next.
          </p>
        </section>

        <section class="powers-grid" aria-label="Reckon Crew super powers profiles">
          <router-link
            v-for="profile in profiles"
            :key="profile.slug"
            :to="{ name: 'super-power-profile', params: { heroSlug: profile.slug } }"
            class="power-profile-card"
          >
            <div class="power-profile-image">
              <v-img
                :src="[profile.heroImage, profile.placeholderImage] | mediaSrc"
                :alt="profile.artAlt"
                aspect-ratio="0.78"
                contain
              ></v-img>
            </div>
            <div class="power-profile-copy">
              <p>{{ profile.realName }}</p>
              <h2>{{ profile.heroName }}</h2>
              <span>{{ profile.heroTitle }}</span>
              <strong>
                View Super Powers
                <v-icon small aria-hidden="true">mdi-arrow-right</v-icon>
              </strong>
            </div>
          </router-link>
        </section>
      </v-container>
    </main>

    <AppFooter></AppFooter>
  </div>
</template>

<script>
import AppFooter from '../components/Footer.vue';
import AppHeader from '../components/Header.vue';
import { heroProfiles } from '../data/heroProfiles';

export default {
  name: 'PowersView',
  components: {
    AppFooter,
    AppHeader,
  },
  computed: {
    profiles() {
      return heroProfiles;
    },
  },
};
</script>

<style scoped>
.powers-page {
  background: #05080c;
  color: #eef7fb;
  min-height: 100vh;
}

.powers-intro {
  margin: 0 auto 42px;
  max-width: 820px;
  text-align: center;
}

.powers-kicker {
  color: #83dcff;
  font-size: 0.78rem;
  font-weight: 900;
  letter-spacing: 0.2em;
  margin: 0 0 10px;
  text-transform: uppercase;
}

.powers-intro h1 {
  color: #fff;
  font-size: clamp(2.4rem, 7vw, 5rem);
  letter-spacing: -0.04em;
  line-height: 0.95;
  margin: 0 0 18px;
}

.powers-intro p:last-child {
  color: #bdcad3;
  font-size: 1.05rem;
  line-height: 1.7;
  margin: 0 auto;
  max-width: 680px;
}

.powers-grid {
  display: grid;
  gap: 22px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding-bottom: 72px;
}

.power-profile-card {
  background: linear-gradient(145deg, rgba(18, 39, 56, 0.88), rgba(8, 13, 20, 0.98));
  border: 1px solid rgba(141, 220, 255, 0.2);
  border-radius: 8px;
  color: #fff !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-decoration: none;
  transition: border-color 180ms ease, transform 180ms ease;
}

.power-profile-card:hover {
  border-color: rgba(141, 220, 255, 0.62);
  transform: translateY(-3px);
}

.power-profile-card:focus-visible {
  outline: 3px solid #9be5ff;
  outline-offset: 5px;
}

.power-profile-image {
  background: #08121d;
  border-bottom: 1px solid rgba(141, 220, 255, 0.14);
  padding: 18px;
}

.power-profile-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 22px;
}

.power-profile-copy p {
  color: #83dcff;
  font-size: 0.75rem;
  font-weight: 900;
  letter-spacing: 0.14em;
  margin: 0 0 8px;
  text-transform: uppercase;
}

.power-profile-copy h2 {
  color: #fff;
  font-size: 1.5rem;
  letter-spacing: -0.02em;
  margin: 0 0 8px;
}

.power-profile-copy span {
  color: #bdcad3;
  line-height: 1.5;
}

.power-profile-copy strong {
  align-items: center;
  color: #bcecff;
  display: inline-flex;
  font-size: 0.78rem;
  gap: 6px;
  letter-spacing: 0.08em;
  margin-top: 24px;
  text-transform: uppercase;
}

.power-profile-copy .v-icon {
  color: inherit;
}

@media (max-width: 960px) {
  .powers-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .powers-grid {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .power-profile-card {
    transition: none;
  }

  .power-profile-card:hover {
    transform: none;
  }
}
</style>
